import { VerticalConstraint } from 'Shared/backend/widgets/VerticalConstraint';
import { MultiLineText, SingleSelect, Text } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap, noteStyle, Wrap } from 'Shared/forms/Wrap';
import type {EmbedLayout} from 'Shared/model/Components';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { Match, Switch } from 'solid-js';


export function EmbedBody(P:EmbedLayout)
{
	return (<>
		<div class={noteStyle()}>
			WARNING: only paste in code from providers you trust. Malicious code can trick visitors into
			providing personal information or display undesirable content on your pages.
			The 'Iframe' option is more secure than the 'Code' option.
		</div>

		<LabelOnLeftWrap label='Embed type'>
			<SingleSelect field='type' options={{iframe:'Iframe',code:'Code'}} required={true} />
		</LabelOnLeftWrap>

		<Switch>
			<Match when={P.type == 'iframe'}>
				<IFrame {...P} />
			</Match>
			<Match when={true}>
				<Js {...P} />
			</Match>
		</Switch>
	</>);
}

function IFrame(P)
{
	const sw = useStore();

	/*
		TIP: leaving the iframe background unset causes it to use the sites background colour.

		Iframe heights are annoying. We could provide https://github.com/davidjbradshaw/iframe-resizer as a built-in 
		if there was a demand for it. This would be more secure than embedding the iframe provider's resizing code. 
		Note the alternative resizing libraries are much less popular.

		NOTE use Container to size it properly...
	*/

//TODO move over to something like this. Strip code out of initContent().
//			afterUpdate={value => value.type=='iframe' ? {} : {height:'500px'} }
//NOTE this initContent version is a bit different - looks like this...
//		ret = {...ret, type:'iframe',height:isTop ? {height:'500px'} : {parent:true}};
//
// ALSO maybe use a new 'updateData' function instead of afterUpdate. It can incorporate a tRPC replace call & store update.

	return (<>
		<StoreProvider {...sw} location={[...sw.location,'height']} >
			<VerticalConstraint {...P.height} label='Height' options={P.heightOptions} />
		</StoreProvider>

		<Wrap label='Embed iframe URL'>
			<Text field='url' required={true} />
		</Wrap>
	</>);
}

function Js(P)
{
	return (
		<div>
			<Wrap label='HTML embed code'>
				<MultiLineText field='code' numRows={8} />
			</Wrap>
		</div>
	);
}

